import React, { useCallback } from 'react'
import Tooltip from 'components/Tooltip'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { StyledButton } from '../../ReleaseInformation.styles'
import { useTranslation } from 'react-i18next'
import jwt_decode from 'jwt-decode'
import ModalActions from 'reducers/Modal'
import {
  releaseInfoReactGridExtraExtraLargeUpQuery,
  releaseInfoSmallDesktopUpQuery
} from '../../responsiveQueries'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

const DownloadSectionCol = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-height: 1px;
  max-width: 100%;
  flex: 0 0 100%;

  @media ${releaseInfoSmallDesktopUpQuery} {
    flex-basis: ${({ $isPromoExpanded }) =>
      $isPromoExpanded ? '83.333333%' : '66.666667%'};
    max-width: ${({ $isPromoExpanded }) =>
      $isPromoExpanded ? '83.333333%' : '66.666667%'};
  }

  @media ${releaseInfoReactGridExtraExtraLargeUpQuery} {
    flex-basis: ${({ $isPromoExpanded }) =>
      $isPromoExpanded ? '83.333333%' : '58.333333%'};
    max-width: ${({ $isPromoExpanded }) =>
      $isPromoExpanded ? '83.333333%' : '58.333333%'};
  }
`

const DownloadSectionLegacy = ({
  release,
  handleDownload,
  isMobile,
  isPromoExpanded
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()
  const { currentReleaseInformation } = useSelector((state) => state.releases)
  const token = localStorage.getItem('accessToken')
  const currentUser = jwt_decode(token)
  const isAbleToShareRelease =
    currentUser?.verified && currentReleaseInformation?.allow_sharing
  const shouldUseSecondary = isAbleToShareRelease && release?.candownload
  const downloadSource = 'release_information_download_section'

  const openShareReleaseModal = useCallback(() => {
    dispatch(ModalActions.toggleShareReleaseModal())
  }, [])

  return (
    <DownloadSectionCol
      $isPromoExpanded={isPromoExpanded}
      $responsiveBreakpointsV2={responsiveBreakpointsV2}
      style={{
        padding: '0 16px',
        gap: '8px',
        display: isMobile ? 'block' : 'flex',
        flexWrap: isMobile ? 'nowrap' : 'wrap'
      }}
    >
      {isAbleToShareRelease && (
        <StyledButton
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
          variant="primary"
          setting="player"
          style={{ maxWidth: isMobile ? '100%' : '120px' }}
          onClick={openShareReleaseModal}
        >
          {t('share-release.share-release')}
        </StyledButton>
      )}

      <Tooltip
        hasArrow={false}
        placement="top"
        text={t('release-info.stream-only-feedback')}
        hidden={release?.candownload}
        wrapperStyles={{ width: isMobile ? '100%' : 'auto' }}
      >
        <StyledButton
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
          variant={shouldUseSecondary ? 'secondary' : 'primary'}
          setting="player"
          onClick={() => handleDownload(release, 'wav', downloadSource)}
          disabled={!release?.candownload}
        >
          {t('general.download-all-wav')}
        </StyledButton>
      </Tooltip>

      <Tooltip
        hasArrow={false}
        placement="top"
        text={t('release-info.stream-only-feedback')}
        hidden={release?.candownload}
        wrapperStyles={{ width: isMobile ? '100%' : 'auto' }}
      >
        <StyledButton
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
          variant="secondary"
          setting="player"
          mode="dark"
          onClick={() => handleDownload(release, 'mp3', downloadSource)}
          disabled={!release?.candownload}
          style={{
            background: !release?.candownload ? 'unset' : ''
          }}
        >
          {t('general.download-all-mp3')}
        </StyledButton>
      </Tooltip>
    </DownloadSectionCol>
  )
}

export default DownloadSectionLegacy
